import React, { useEffect } from "react";

// router
import { BrowserRouter as Router, Switch, Redirect } from "react-router-dom";

// MUI
import {
  makeStyles,
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";

// components
import Home from "./views/Home";
import Login from "./views/Login";
import Navbar from "./components/NavBar/NavBar";
import { colors, Container } from "@material-ui/core";
import Category from "./views/Category";
import Product from "./views/Product";
import AppContainer from "./views/App";
import SmartApp from "./views/SmartApp";
import ProductCategory from "./views/ProductCategory";
import Advertisement from "./views/Advertisement";
import SingleAdvertisement from "./views/Advertisement/Single";
import AuthRouter from "./util/AuthRouter";
import PrivateRoute from "./util/PrivateRoute";
import { getAdminData } from "./db";
import { useStateValue } from "./store/provider";
import { LOGIN, SET_IS_AUTH } from "./store/reducer";
import Profile from "./views/Profile";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
  },
}));

const theme = createMuiTheme({
  palette: {
    background: {
      dark: "#F4F6F8",
      default: colors.common.white,
      paper: colors.common.white,
    },
    primary: {
      main: colors.indigo[500],
    },
    secondary: {
      main: colors.indigo[500],
    },
    text: {
      primary: colors.blueGrey[900],
      secondary: colors.blueGrey[600],
    },
  },
  props: {
    MuiTextField: {
      size: "small",
      required: true,
      fullWidth: true,
      type: "text",
      variant: "outlined",
    },
    MuiTableCell: {
      align: "center",
    },
    MuiSelect: {
      defaultValue: "",
    },
  },
  overrides: {
    MuiTableCell: {
      head: {
        backgroundColor: colors.blue[600],
        color: colors.common.white,
      },
    },

    MuiToolbar: {
      gutters: {
        "@media (min-width: 600px)": {
          paddingLeft: "5px",
          paddingRight: "24px",
        },
      },
    },
  },
});

function App() {
  const classes = useStyles();

  const [, dispatch] = useStateValue();

  const isAuth = localStorage.getItem("isAuth");
  const adminId = localStorage.getItem("id");

  useEffect(() => {
    if (isAuth) {
      dispatch({ type: SET_IS_AUTH });
      getAdmin(adminId);
    }
  }, [isAuth, adminId]);

  const getAdmin = async (id) => {
    const data = await getAdminData(id);
    dispatch({ type: LOGIN, payload: { ...data, id } });
  };

  return (
    <Router>
      <MuiThemeProvider theme={theme}>
        <div className={classes.root}>
          <CssBaseline />
          <Navbar />
          <main className={classes.content}>
            <div className={classes.toolbar} />
            <Container style={{ marginTop: 20 }}>
              <Switch>
                <PrivateRoute exact path="/dashboard" component={Home} />
                <PrivateRoute exact path="/profile" component={Profile} />
                <PrivateRoute exact path="/category" component={Category} />
                <PrivateRoute exact path="/app" component={AppContainer} />
                <PrivateRoute exact path="/smartapp" component={SmartApp} />
                <PrivateRoute exact path="/product" component={Product} />

                <PrivateRoute
                  exact
                  path="/productCategory"
                  component={ProductCategory}
                />
                <PrivateRoute
                  exact
                  path="/advertisement"
                  component={Advertisement}
                />
                <PrivateRoute
                  exact
                  path="/advertisement/:id"
                  component={SingleAdvertisement}
                />
                <AuthRouter exact path="/login" component={Login}></AuthRouter>

                <Redirect to="/login" />
              </Switch>
            </Container>
          </main>
        </div>
      </MuiThemeProvider>
    </Router>
  );
}

export default App;
